import {gql} from '@apollo/client';

export const SWAP_PICKUP_TASK_APPOINTMENTS = gql`
  mutation SwapPickupTaskAppointments(
    $taskId: String!
    $firstAppointmentId: String!
    $secondAppointmentId: String!
  ) {
    swapPickupTaskAppointments(
      taskId: $taskId
      firstAppointmentId: $firstAppointmentId
      secondAppointmentId: $secondAppointmentId
    )
  }
`; 